module.exports = __webpack_public_path__ + "static/media/item_13_5_comp.fcb2db36.png";